export default __webpack_public_path__ + "static/media/news17.81b04472.jpg";